/**
 * Standard sort for payment method dropdowns across the app.
 * Order: Active credit/debit cards alphabetically, then CASH,
 * then Points methods alphabetically, then inactive methods last.
 */
export const sortPaymentMethods = (methods) => {
  if (!methods || !Array.isArray(methods)) return [];

  return [...methods].sort((a, b) => {
    // 1. Active before inactive
    const aActive = a.active !== false;
    const bActive = b.active !== false;
    if (aActive !== bActive) return aActive ? -1 : 1;

    // 2. Points methods go to the bottom (within active group)
    const aIsPoints = (a.name || '').toLowerCase().startsWith('points');
    const bIsPoints = (b.name || '').toLowerCase().startsWith('points');
    if (aIsPoints !== bIsPoints) return aIsPoints ? 1 : -1;

    // 3. CASH goes just above Points
    const aIsCash = (a.name || '').toUpperCase() === 'CASH';
    const bIsCash = (b.name || '').toUpperCase() === 'CASH';
    if (aIsCash !== bIsCash) return aIsCash ? 1 : -1;

    // 4. Alphabetical by name
    return (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' });
  });
};
